import { render } from "./SoftSkills.vue?vue&type=template&id=a6eb7c70&scoped=true"
import script from "./SoftSkills.vue?vue&type=script&lang=js"
export * from "./SoftSkills.vue?vue&type=script&lang=js"

import "./SoftSkills.vue?vue&type=style&index=0&id=a6eb7c70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6eb7c70"]])

export default __exports__